
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[faq]",
      function () {
        return require("private-next-pages/faq/[faq].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/[faq]"])
      });
    }
  